import * as React from 'react';
import type { SVGProps } from 'react';
const SvgExpandLess = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={12}
    height={8}
    fill="none"
    viewBox="0 0 12 8"
    {...props}
  >
    <path
      fill="currentColor"
      d="m6 2.875-4.1 4.1a.875.875 0 0 1-1.275 0 .875.875 0 0 1 .008-1.283L5.375.95a.907.907 0 0 1 .63-.25q.18 0 .337.063a.8.8 0 0 1 .283.187l4.741 4.742q.285.284.284.633a.86.86 0 0 1-.275.625.875.875 0 0 1-1.275 0z"
    />
  </svg>
);
export default SvgExpandLess;
